import React from 'react';
import * as cornerstone from 'cornerstone-core';
import { DateTime } from 'luxon';
import {
  Card,
  ThumbnailContainer,
  Thumbnail,
  ModalityBadge,
  InfoContainer,
  Description,
  Details,
} from './styles';

const ExamCard = ({
  exam,
  onClick,
  selected,
  loadDicomImage,
  zipFiles,
  loadedImages,
  setLoadedImages,
}) => {
  return (
    <Card onClick={onClick} selected={selected}>
      <ThumbnailContainer>
        <Thumbnail
          ref={async (el) => {
            if (el && !el.cornerstoneEnabled) {
              try {
                cornerstone.enable(el);
                el.cornerstoneEnabled = true;
                if (exam.images?.[0]) {
                  const image = await loadDicomImage(
                    exam.images[0].referencedFile,
                    zipFiles,
                    loadedImages,
                    setLoadedImages
                  );
                  if (image) {
                    cornerstone.displayImage(el, image);
                  }
                }
              } catch (error) {
                console.error('Error loading thumbnail:', error);
              }
            }
          }}
        />
        <ModalityBadge>{exam.modality}</ModalityBadge>
      </ThumbnailContainer>
      <InfoContainer>
        <div>
          <Description>{exam.description}</Description>
        </div>
        <Details>
          <span>
            {exam.studyDate && exam.studyDate !== 'N/A'
              ? DateTime.fromFormat(exam.studyDate, 'yyyyMMdd').toFormat('dd/MM/yyyy')
              : 'N/A'}
          </span>
        </Details>
      </InfoContainer>
    </Card>
  );
};

export default ExamCard;
